export default __webpack_public_path__ + "static/office1-1x-4b5cd165b703f4c68f009c1c089447e3.jpg";